/* eslint-disable import/prefer-default-export */
const localDateObj = (dateString) => {
  /**
   * Replaces dashes with slashes to ensure that the provided string is interpreted with
   * local timezone rather than converted to UTC by Date(). This is important because
   * methods like .getDate() will retrieve datetime pieces based on the
   * date objects representation in the local timezone. Therefore, we need to match the
   * timezone of the input and the output to prevent this implicit conversion.
   *
   * This is due to Date() interpreting a YYYY-MM-DD string input as UTC, but all
   * other formats (e.g. YYYY/MM/DD, YYYY-MM-DD HH:II:SS, etc.) as local time.
   */
  const modifiedDateString = dateString.replace('-', '/');
  return new Date(modifiedDateString);
};

export const formatDate = (dateString, returnNullOnNonFutureDate = false) => {
  const dateObj = localDateObj(dateString);
  if (returnNullOnNonFutureDate && (new Date() >= dateObj)) {
    return null;
  }
  return `${dateObj.getMonth() + 1} / ${dateObj.getDate()} / ${dateObj.getFullYear()}`;
};
